export default __webpack_public_path__ + "static/media/MaroonTicketIcon.dbce7cae.png";